import React from 'react'
import styled, { css } from 'styled-components'
import addToMailchimp from 'gatsby-plugin-mailchimp'

import InputText from '../InputText'
import InputEmail from '../InputEmail'
import Submit from '../Submit'

// import { container, bgImage, button, bgIcon, hoverState, padding } from "../../styles/global"
import { heading } from '../../styles/type';
import { width, media } from "../../styles/utils"
import { grey,red } from '../../styles/colors'


class SignupForm extends React.Component {

    state = {
        email: '',
        emailError: false,
        emailErrorMessage: 'This field is required.',
        showErrors: false,
        shakeOnError: false,
        formSuccess: false,
        formError: false,
        formErrorMessage: '',
        processing: false,

    }

    handleFieldChange = (key, value) => {

        if(this.state.emailError){
            this.setState({ emailError: false })
        }
        this.setState({
            [key]: value
        })
    }
 
    validateEmail = () => {        
        let val = this.state.email;

        var emailTest = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailTest.test(val)) {
            this.setState({
                emailError: false,
                emailErrorMessage: ''
            })
            return true;
        } else {
            this.setState({
                processing: false,
                emailError: true,
                shakeOnError: true,
                emailErrorMessage: 'The email address you submitted was not valid'
            })
            return false;
        }
    }

	handleSubmit = () => {

        let valid = false;
        valid = this.validateEmail(this.state.email)

        if (valid) {

            this.setState({ processing: true })


            
            addToMailchimp(this.state.email).then(data => {

                //console.log('mc data',data);

                this.setState({ processing: false })

                if (data.result=='success') {
                    this.setState({
                        formSuccess: true,
                        email: ''
                    })
                }

                if (data.result=='error') {
                    this.setState({
                        formError: true,
                        formErrorMessage: data.msg
                    })
                } 
            })
        }
    }

	render() {

		return (
            <Wrapper>

 
                <Form>

                    <Heading>Subscribe to newsletter</Heading>

                    <Fields
                        error={this.state.emailError}
                        shakeOnError={this.state.shakeOnError}   
                    >
            
                        <Email
                            label="Email"
                            placeholder="Email address"
                            value={this.state.email}
                            onBlur={(e) => this.validateEmail()}
                            onChangeValue={(e) => this.handleFieldChange('email',e.target.value)}
                            error={this.state.emailError}
                            errorMessage={this.state.emailErrorMessage}
                            showErrors={this.state.showErrors}
                            shakeOnError={this.state.shakeOnError}     
                        />

                        <SubmitForm
                            label=""              
                            handleSubmit={this.handleSubmit}
                            processing={this.state.processing}
                        />

                        

                    </Fields>       

                        {this.state.emailError  && (
                        <Error>
                            {this.state.emailErrorMessage}
                        </Error>
                    )}

                </Form>
            

                {this.state.formSuccess && (
                    <Success>Thank you for subscribing</Success>
                )}     

                {this.state.formError && (
                    <Error 
                        dangerouslySetInnerHTML={{__html: this.state.formErrorMessage }}
                    />      
                )}

    

            </Wrapper>
		)
	}
}

const Wrapper = styled.div`
`

const Form = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
`

const Heading = styled.div`
    font-family: 'Scto';
    font-size: 24px;
    color: #595850;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    margin-bottom: 40px;
`
const Fields = styled.div`
    display: flex;
    max-width: 440px;
    width: 100%;

    ${props => {
       
       if (props.shakeOnError && props.error) {

           return css`

               animation: shakin 0.4s 1 linear;
               @keyframes shakin {
                   0% { -webkit-transform: translate(30px); }
                   20% { -webkit-transform: translate(-30px); }
                   40% { -webkit-transform: translate(15px); }
                   60% { -webkit-transform: translate(-15px); }
                   80% { -webkit-transform: translate(8px); }
                   100% { -webkit-transform: translate(0px); }
               }

           `
       }
   }}

`
const Email = styled(InputEmail)`
    flex-grow: 2;
    width: 390px;
    ${media.phone`
        width: 250px;
    `}
`
const SubmitForm = styled(Submit)``




const Success = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 16px;

    font-family: 'Scto';
    font-size: 14px;
    color: rgba(89,88,80,0.50);
    letter-spacing: 0;
    text-align: center;
    line-height: 16px;

    /* ${media.phone`
        font-size: 18px;
        padding: 0 32px;
    `}  */
`

const Error = styled.div`
    width: 440px;
    max-width: 100%;
    text-align: center;
    margin-top: 16px;
    font-family: 'Scto';
    font-size: 14px;
    color: rgba(89,88,80,0.50) !important;
    letter-spacing: 0;
    text-align: center;
    line-height: 16px;

    


    ${media.phone`
        width: 241px;
    `} 
`




export default SignupForm;


// WEBPACK FOOTER //
// ./src/components/SignupForm/SignupForm.js